export default __webpack_public_path__ + "static/media/contact.7384cfb9.png";